import { Children, cloneElement } from "react";

import { useHasFeature } from "@/hooks/useHasFeature";
import { useIntercom } from "@/hooks/useIntercom";
import Tooltip from "@components/Tooltip";

const UpsaleOverlay = ({
  children,
  message = L.MENTIONS_VIEW_TOOLBAR_UPSALE_TOOLTIP,
}) => {
  const child = Children.only(children);
  const { show } = useIntercom();

  return (
    <Tooltip content={message}>
      {cloneElement(child, {
        onClick: (e) => {
          e.stopPropagation();
          e.preventDefault();
          show?.();
        },
      })}
    </Tooltip>
  );
};

export default UpsaleOverlay;

export const withUpsaleOverlay =
  (Component, { feature }) =>
  ({ ...props }) => {
    const hasFeature = useHasFeature(feature);
    const WrappedComponent = hasFeature ? (
      <Component {...props} />
    ) : (
      <UpsaleOverlay>
        <div>
          {cloneElement(<Component />, {
            onClick: undefined,
            href: "",
            disabled: true,
          })}
        </div>
      </UpsaleOverlay>
    );

    return WrappedComponent;
  };
